// Predefined commands for AskMe feature
import {Command, CommandParameter} from '../models/askme/command.js'

export const ASKME_COMMANDS = [

  new Command({
    id: 'attendance',
    title: 'Overall Attendance',
    description: 'Get report on the attendance overall or of selected classes',
    command: 'get overall attendance report for {0}',
    category: 'reports',
    parameters: [
      new CommandParameter({
        name: 'day',
        type: 'string',
        displayName: 'Day',
        placeholder: 'e.g. today, yesterday, August 12, etc.',
        required: true
      })
    ],
    submitButtonText: 'Insert Command'
  }),

  new Command({
    id: 'class-attendance',
    title: 'Class Attendance',
    description: 'Get report on the attendance of selected classes',
    command: 'get attendance report for {0}. Additionally, show the attendance in a pie chart',
    category: 'reports',
    parameters: [
      new CommandParameter({
        name: 'classSelection',
        type: 'string',
        displayName: 'Class/Section',
        placeholder: 'e.g. 10a, 4b, etc.',
        required: true
      })
    ],
    submitButtonText: 'Insert Command'
  }),
  
  new Command({
    id: 'subject-performance',
    title: 'Subject Performance Report',
    description: 'Analyze student performance across different subjects and identify areas for improvement',
    command: `get me the {2} subject performance of {0} for {1} in academic year {3}.`,
    category: 'reports',
    parameters: [
     
      new CommandParameter({
        name: 'classSelection',
        type: 'string',
        displayName: 'Class/Section',
        placeholder: 'e.g., class 10a or 4 a and b, etc.',
        required: true
      }),
      new CommandParameter({
        name: 'exam',
        type: 'string',
        displayName: 'Exam',
        placeholder: 'e.g., pt1, first term exam, final exam, etc.',
        required: true
      }),
      new CommandParameter({
        name: 'subject',
        type: 'string',
        displayName: 'Subject (optional)',
        placeholder: 'e.g., Mathematics, Science, English',
        required: false
      }),
      new CommandParameter({
        name: 'academicYear',
        type: 'academicYear',
        displayName: 'Academic Year',
        required: false
      })
    ],
    submitButtonText: 'Insert Command'
  }),

  new Command({
    id: 'class-performance',
    title: 'Class Performance Report',
    description: 'Get comprehensive overview of class performance metrics',
    command: `get me the performance report of {0} for {1} in academic year {2}.
     Use a bar chart to showcase the subject performance.
    Additionally, using a line chart, show the progress of the main subjects across different exams.`,
    category: 'analytics',
    parameters: [
      new CommandParameter({
        name: 'classSelection',
        type: 'string',
        displayName: 'Class/Section',
        placeholder: 'e.g. 10a, 4b, etc.',
        required: true
      }),
      new CommandParameter({
        name: 'exam',
        type: 'string',
        displayName: 'Exam',
        placeholder: 'e.g., pt1, first term exam, final exam, etc.',
        required: true
      }),
      new CommandParameter({
        name: 'academicYear',
        type: 'academicYear',
        displayName: 'Academic Year',
        required: false
      })
    ],
    submitButtonText: 'Insert Command'
  }),

  new Command({
    id: 'performance-trend',
    title: 'Performance Trend',
    description: 'Get the performance trend of the class to analyse how the class is performing over time',
    command: `get me the performance trend of {0} across all exams in academic year {1}.
     If applicable, show a line chart representing the performance trend.
     Additionally, give a summary of the performance trend.`,
    category: 'analytics',
    parameters: [
      new CommandParameter({
        name: 'classSelection',
        type: 'string',
        displayName: 'Class/Section',
        placeholder: 'e.g. 10a, 4b, etc.',
        required: true
      }),
      new CommandParameter({
        name: 'academicYear',
        type: 'academicYear',
        displayName: 'Academic Year',
        required: false
      })
    ],
    submitButtonText: 'Insert Command'
  }),

  new Command({
    id: 'class-toppers',
    title: 'Class Toppers',
    description: 'Get the toppers of the class',
    command: `get me 6 toppers of {0} for {1} in academic year {2}.`,
    category: 'analytics',
    parameters: [
      new CommandParameter({
        name: 'classSelection',
        type: 'string',
        displayName: 'Class/Section',
        placeholder: 'e.g. 10a, 4b, etc.',
        required: true
      }),
      new CommandParameter({
        name: 'exam',
        type: 'string',
        displayName: 'Exam',
        placeholder: 'e.g., pt1, first term exam, final exam, etc.',
        required: true
      }),
      new CommandParameter({
        name: 'academicYear',
        type: 'academicYear',
        displayName: 'Academic Year',
        required: false
      })
    ],
    submitButtonText: 'Insert Command'
  }),


  new Command({
    id: 'student-progress',
    title: 'Student Progress Report',
    description: 'Get comprehensive overview of student performance metrics',
    command: `get me the performance report of {0} for the academic year {1}.`,
    category: 'analytics',
    parameters: [
      new CommandParameter({
        name: 'studentName',
        type: 'string',
        displayName: 'Student Name',
        placeholder: 'e.g., John Doe or Student ID',
        required: true
      }),
      new CommandParameter({
        name: 'academicYear',
        type: 'academicYear',
        displayName: 'Academic Year',
        placeholder: 'e.g., 2024-25',
        required: false
      })
    ],
    submitButtonText: 'Insert Command'
  }),

  new Command({
    id: 'diary-report',
    title: 'Diary Report',
    description: 'Get the details of diaries for the selected class',
    command: `get me the diaries of {0}`,
    category: 'academic',
    parameters: [
      new CommandParameter({
        name: 'classSelection',
        type: 'string',
        displayName: 'Class/Section',
        placeholder: 'e.g., 10a, 4b, etc.',
        required: true
      })
    ],
    submitButtonText: 'Insert Command'
  }),

  // new Command({
  //   id: 'fee-collection',
  //   title: 'Fee Collection Report',
  //   description: 'Generate comprehensive fee collection reports for classes or individual students',
  //   command: 'generate fee collection report for {0} showing {1} in academic year {2}',
  //   category: 'finance',
  //   parameters: [
  //     new CommandParameter({
  //       name: 'target',
  //       type: 'string',
  //       displayName: 'Target',
  //       placeholder: 'e.g., Class 10A, John Doe, or "all students"',
  //       required: true
  //     }),
  //     new CommandParameter({
  //       name: 'reportType',
  //       type: 'string',
  //       displayName: 'Report Type',
  //       placeholder: 'e.g., "pending fees", "collected fees", "summary"',
  //       required: true
  //     }),
  //     new CommandParameter({
  //       name: 'academicYear',
  //       type: 'academicYear',
  //       displayName: 'Academic Year',
  //       required: true
  //     })
  //   ],
  //   submitButtonText: 'Insert Command'
  // })
];

// Categories for organizing commands
export const COMMAND_CATEGORIES = {
  reports: 'Reports',
  analytics: 'Analytics',
  finance: 'Finance',
  academic: 'Academic',
  staff: 'Staff Management',
  resources: 'Resources',
};

export default ASKME_COMMANDS;
